"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.activacionNormalizer = void 0;
const mocks_json_1 = __importDefault(require("./mocks.json"));
const utils_common_to_kebap_case_1 = __importDefault(require("@gcloud-npm/utils.common.to-kebap-case"));
/**
 * normalizador del modulo MODULO_CARACTERISTIC_CARDS
 * @param {object} fields
 * @returns
 */
const activacionNormalizer = (data) => {
    let res = null;
    try {
        if (data) {
            const { fields } = data;
            if (fields) {
                res = {};
                const title = fields.title;
                const link = fields.href || fields.link;
                const icon = fields.icon;
                const description = fields.description;
                res.component = "activacion";
                if (title) {
                    res["Text-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-1"]), { text: title });
                }
                res["CustomLink-1"] = Object.assign(Object.assign({}, mocks_json_1.default["CustomLink-1"]), { href: link || "", label: description || "" });
                if (icon) {
                    res["Glyph-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Glyph-1"]), { id: (0, utils_common_to_kebap_case_1.default)(icon) });
                }
            }
        }
        return res;
    }
    catch (error) {
        console.error(error);
        return null;
    }
};
exports.activacionNormalizer = activacionNormalizer;
exports.default = exports.activacionNormalizer;
//# sourceMappingURL=index.js.map